import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
// Toggles a dropdown panel and closes it on an outside click.
export default class extends Controller {
    static targets = ["panel"]

    toggle(event) {
        event.stopPropagation()
        this.panelTarget.classList.toggle("hidden")
    }

    closeOnOutsideClick(event) {
        if (!this.element.contains(event.target)) this.panelTarget.classList.add("hidden")
    }
}
